import { render } from "./CommonEditingForm.vue?vue&type=template&id=6d2ef836"
import script from "./CommonEditingForm.vue?vue&type=script&lang=js"
export * from "./CommonEditingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__